import React, { useEffect, useRef, useState } from "react";
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../../ui/dropdown-menu";
import { Input } from "../../ui/input";
import { Button } from "../../ui/button";
import { Field, Form } from "react-final-form";
import { Link, useNavigate } from "react-router-dom";
import {
  composeValidators,
  pinCodeRestriction,
  preventNonNumericAndRestrictDecimal,
  preventNonNumericAndRestrictLength,
  renderField,
  renderTabField,
  required,
} from "../../../helpers/form-validations";
import { meta } from "eslint-plugin-prettier";
import { IoIosArrowBack, IoIosArrowDown } from "react-icons/io";
import { Label } from "../../ui/label";
import { DatePicker } from "../../ui/date-picker";
import axios from "axios";
import {
  createInvestor,
  editEmployee,
  editInvestor,
  getEmailTemplatesDropdown,
  getInvestorsDropdown,
  getSchemesDropdown,
} from "../../../utils/util";
import { useSearchParams } from "react-router-dom";
import AdvancedDropdown from "../../ui/multi-selection-dropdown-menu-with-search";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogOverlay,
  DialogTitle,
} from "@radix-ui/react-dialog";
import { useDispatch, useSelector } from "react-redux";
import { loaderSet } from "../../../context/actions/loaderAction";
import {
  alertDanger,
  alertSuccess,
} from "../../../context/actions/toastAction";
import { nullInvestorInfo } from "../../../context/actions/investorInfoAction";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../ui/tabs";
import Loader from "../../loader";
import { setAllSchemeDetails } from "../../../context/actions/allSchemeDetailsAction";
import { setAllInvestorDetails } from "../../../context/actions/allInvestorDetailsAction";

// import PhoneInput from 'react-phone-number-input';
// import 'react-phone-number-input/style.css'; // Import CSS for styling the phone input

import PhoneInput from "react-phone-input-2";

import "react-phone-input-2/lib/semantic-ui.css";
import { DatePickerForSchemes } from "../../ui/datePickerForSchemes";
import { IndianRupee } from "lucide-react";
import { truncateToDecimalPlaces } from "../../../utils/helper";

const CreateInvestor = ({
  back,
  setActiveTab,
  getAllInvestor,
  forWhichUserType = "admin",
}) => {
  const allEmailTemplateDetailsForDropdown = useSelector(
    (state) => state.allEmailTemplateDetails
  );
  const allSchemeDetailsForDropdown = useSelector(
    (state) => state.allSchemeDetails
  );
  const investorInfo = useSelector((state) => state.investorInfo);
  const navigate = useNavigate();
  const [selectedSchemeOptions, setSelectedSchemeOptions] = useState([]);
  const [
    selectedStatusOrConstitutionOptions,
    setselectedStatusOrConstitutionOptions,
  ] = useState(
    investorInfo && investorInfo?.constitution
      ? [investorInfo?.constitution]
      : []
  );

  const [selectedScheme, setSelectedScheme] = useState("Select Schemes");
  const [selectedCountry, setSelectedCountry] = useState(
    investorInfo ? investorInfo?.country : "Select Country"
  );
  const [selectedClassOptions, setSelectedClassOptions] = useState([]);
  const [selectedInvestorOptions, setSelectedInvestorOptions] = useState([]);
  const buttonRef = useRef(null);
  const [dropdownWidth, setDropdownWidth] = useState("auto");
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.user);
  const employeeInfo = useSelector((state) => state.employeeInfo);
  const [isLoading, setIsLoading] = useState(false);

  const [
    isOpenUploadDocumentConfirmation,
    setIsOpenUploadDocumentConfirmation,
  ] = useState(false);

  const handleIsOpenUploadDocumentConfirmation = () => {
    setIsOpenUploadDocumentConfirmation(true);
  };
  const handleIsCloseUploadDocumentConfirmation = () => {
    setIsOpenUploadDocumentConfirmation(false);
  };
  const userId = searchParams.get("user_id");
  let actionType = searchParams.get("action_type");
  useEffect(() => {
    console.log("User ID:", userId);
    console.log("Action Type:", actionType);
    // You can use these values as needed, for example, making API calls
    console.log("from redux investor Info", investorInfo);
  }, [userId, actionType]);

  // Effect to set the dropdown content width to the button width
  useEffect(() => {
    if (buttonRef.current) {
      setDropdownWidth(`${buttonRef.current.offsetWidth}px`);
    }
  }, []);

  const [countries, setCountries] = useState(["India"]);
  const [phoneNumberWithCountryCode, setPhoneNumberWithCountryCode] = useState(
    investorInfo ? investorInfo?.mobile_number : null
  );
  const [searchCountry, setSearchCountry] = useState(""); // State for search input
  const [selectedClass, setSelectedClass] = useState(
    investorInfo ? investorInfo?.class : "Select Class"
  );
  // const [selectedSChemeAndCLass,setSelectedSChemeAndCLass]=useState(["scheme 1-Class A","scheme 2-Class B","scheme 3-Class C"])
  const [selectedSChemeAndCLass, setSelectedSChemeAndCLass] = useState([]);

  const [schemeOption, setSchemeOption] = useState(() => {
    return Array.isArray(allSchemeDetailsForDropdown) &&
      allSchemeDetailsForDropdown.length > 0
      ? allSchemeDetailsForDropdown
        .filter((scheme) => scheme && scheme.scheme_name) // Filter out null or undefined values and entries without `scheme_name`
        .map((scheme) => scheme.scheme_name)
      : [];
  });

  const [statusOrConstitution, setStatusOrConstitution] = useState([
    "Resident Individual",
    "Non-resident Individual",
    "Foreign Citizen",
    "Limited Liability Partnership",
    "Corporates",
    "Trusts",
    "Non-Corporate (other than Trusts)",
    "AIFs",
    "Others",
  ]);

  const [classOption, setClassOption] = useState([]);

  useEffect(() => {
    if (allSchemeDetailsForDropdown && allSchemeDetailsForDropdown.length > 0) {
      const filteredClassOptions = allSchemeDetailsForDropdown
        .filter(
          (scheme) =>
            scheme.scheme_name === selectedSchemeOptions[0] &&
            scheme.scheme_class !== undefined &&
            scheme.scheme_class !== null
        )
        .flatMap((scheme) => scheme.scheme_class); // Flatten nested scheme_class arrays

      setClassOption(filteredClassOptions);
    }
  }, [allSchemeDetailsForDropdown, selectedSchemeOptions]);

  // const fetchCountries = async () => {
  //   try {
  //     // const response = await axios.get("https://restcountries.com/v3.1/all");

  //     console.log("responseCountries", response);

  //     const countryList = response.data.map(
  //       (country) =>
  //         `${country.name.common} (${country.idd?.root || ""}${country.idd?.suffixes?.[0] || ""})`
  //     );
  //     setCountries(countryList);

  //     console.log("Countries fetched successfully:", countryList);
  //     console.log("Countries:", countries);

  //   } catch (error) {
  //     console.error("Error fetching countries:", error);
  //     // Retry logic
  //     setTimeout(fetchCountries, 3000);
  //   }
  // };

  const fetchCountries = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/investor/countries`
      );

      const countryList = response.data.data.map(
        (country) => country.name // or customize as needed
      );
      setCountries(countryList);
    } catch (error) {
      console.error("Error fetching countries:", error);
      setTimeout(fetchCountries, 3000);
    }
  };

  useEffect(() => {
    fetchCountries();
  }, []);

  // Function to remove a file

  const handleFileUpload = (event, index) => {
    const files = Array.from(event.target.files); // Convert FileList to an array

    setSchemesDetailsOnTheBasisOfSelectedSchemeAndClass((prevState) => {
      const updatedState = [...prevState];

      // Ensure the object exists at the given index
      if (!updatedState[index]) {
        updatedState[index] = {
          documents: [], // Initialize documents array
          // Include other fields if necessary
        };
      }

      // Ensure the documents array exists
      if (!updatedState[index].documents) {
        updatedState[index].documents = [];
      }

      // Filter out files that are already in the documents array
      const existingFiles = updatedState[index].documents.map(
        (file) => file.name
      ); // Use file.name to check uniqueness
      const newFiles = files.filter(
        (file) => !existingFiles.includes(file.name)
      );

      // Add the new files to the documents array
      updatedState[index].documents = [
        ...updatedState[index].documents,
        ...newFiles,
      ];

      return updatedState;
    });
  };

  const handleRemoveFile = (index, fileIndex) => {
    setSchemesDetailsOnTheBasisOfSelectedSchemeAndClass((prevState) => {
      const updatedState = [...prevState]; // Create a shallow copy of the state

      // Check if the documents array exists for the given index
      if (updatedState[index]?.documents) {
        // Filter out the file at the specified fileIndex
        updatedState[index].documents = updatedState[index].documents.filter(
          (_, i) => i !== fileIndex
        );
      }

      return updatedState; // Return the updated state
    });
  };

  const filteredCountries = countries
    .filter((country) =>
      country.toLowerCase().includes(searchCountry.toLowerCase())
    )
    .sort((a, b) => a.localeCompare(b));

  console.log("filter", filteredCountries);

  // Assuming you're using react-hook-form
  const [emailTemplateOption, setEmailTemplateOption] = useState([]);
  const [selectedEmailTemplateOptions, setSelectedEmailTemplateOptions] =
    useState([]);

  useEffect(() => {
    if (
      allEmailTemplateDetailsForDropdown &&
      allEmailTemplateDetailsForDropdown.length > 0
    ) {
      const filteredEmailTemplateOptions = allEmailTemplateDetailsForDropdown
        .filter((emailTemplate) => emailTemplate.template_name !== null)
        .map((emailTemplate) => {
          return emailTemplate.template_name;
        });

      setEmailTemplateOption(filteredEmailTemplateOptions);
    }
  }, [allEmailTemplateDetailsForDropdown]);

  useEffect(() => {
    const fetchEmailTemplatesForDropdown = async () => {
      try {
        const response = await getEmailTemplatesDropdown();
        if (response) {
          setEmailTemplateOption(
            response?.data
              .filter((emailTemplate) => emailTemplate.template_name !== null)
              .map((emailTemplate, index) => emailTemplate.template_name)
          );
        }
      } catch (error) {
        console.log("Error in get email template API", error);
      }
    };

    fetchEmailTemplatesForDropdown(); // Call the async function inside useEffect
  }, []); // The empty dependency array ensures this runs only once on component mount

  useEffect(() => {
    if (selectedSchemeOptions?.length > 0 && selectedClassOptions?.length > 0) {
      const combinedValue = `${selectedSchemeOptions}-${selectedClassOptions}`;
      setSelectedSChemeAndCLass((prev) => {
        if (!prev.includes(combinedValue)) {
          return [...prev, combinedValue]; // Add only if it's not a duplicate
        }
        return prev; // If it's already in the array, return the current state
      });

      console.log(
        "selectedSchemeOptions?.length>0 && selectedClassOptions?.length>0 setSelectedSChemeAndCLass ",
        selectedSChemeAndCLass
      );
      setSelectedClassOptions([]);
    }
  }, [selectedSchemeOptions, selectedClassOptions]);

  const handleRemoveSchemeAndClass = (indexToRemove) => {
    setSelectedSChemeAndCLass((prev) =>
      prev.filter((_, index) => index !== indexToRemove)
    );
    setSchemesDetailsOnTheBasisOfSelectedSchemeAndClass((prev) =>
      prev.filter((_, index) => index !== indexToRemove)
    );
  };

  useEffect(() => {
    if (investorInfo) {
      const combinedValue = investorInfo?.schemes?.map(
        (scheme, index) => `${scheme.scheme_name}-${scheme.scheme_class}`
      );
      setSelectedSChemeAndCLass(combinedValue);
    }
  }, [investorInfo]);

  const [
    schemesDetailsOnTheBasisOfSelectedSchemeAndClass,
    setSchemesDetailsOnTheBasisOfSelectedSchemeAndClass,
  ] = useState([]);

  const [validationErrors, setValidationErrors] = useState({});

  const validateField = (fieldName, value, index) => {
    const errors = { ...validationErrors };
    if (!value) {
      errors[`${fieldName}-${index}`] = "Required.";
    } else {
      delete errors[`${fieldName}-${index}`];
    }
    setValidationErrors(errors);
  };

  const handleFieldChange = (index, field, value) => {
    console.log("Updating Field:", { index, field, value });
    setSchemesDetailsOnTheBasisOfSelectedSchemeAndClass((prevState) => {
      const updatedState = [...prevState];

      // Ensure the object exists at the given index
      if (!updatedState[index]) {
        const schemeName = selectedSChemeAndCLass[index].split("-")[0];
        const schemeClass = selectedSChemeAndCLass[index].split("-")[1];

        const matchingNav =
          allSchemeDetailsForDropdown &&
          allSchemeDetailsForDropdown.length > 0 &&
          allSchemeDetailsForDropdown?.find(
            (nav) =>
              nav?.scheme_name === schemeName &&
              Array.isArray(nav?.nav) && // Ensure nav is an array
              nav?.nav?.some((n) => n.class === schemeClass)
          );

        const navValue = matchingNav
          ? matchingNav?.nav.find((n) => n.class === schemeClass)?.value || ""
          : "";

        updatedState[index] = {
          scheme_name_and_scheme_class: selectedSChemeAndCLass[index],
          folio_number: "",
          ckyc_number: "",
          scheme_name: schemeName,
          scheme_class: schemeClass,
          nav: navValue, // Use the found nav value or default to an empty string
          contribution: 0, // Initialize total_investment
          valuation: 0, // Initialize valuation
          purchase_value: 0, // Initialize face_value
          number_of_units: 0, // Initialize number_of_units
          contribution_aggrement_date: "", // Add default value for contribution_aggrement_date
          date_of_investment: "", // Add default value for date_of_investment
          date_of_allotement_units: "", // Add default value for date_of_allotement_units
        };
      }

      // Update the specified field
      updatedState[index][field] = value;

      if (
        updatedState[index].purchase_value &&
        updatedState[index].contribution
      ) {
        const contribution = Number(updatedState[index].contribution);
        const purchaseValue = Number(updatedState[index].purchase_value);

        if (
          !isNaN(contribution) &&
          !isNaN(purchaseValue) &&
          purchaseValue !== 0
        ) {
          updatedState[index].number_of_units = truncateToDecimalPlaces(
            contribution / purchaseValue,
            2
          ); // process name is crunted
        } else {
          updatedState[index].number_of_units = "0.00"; // Fallback for invalid values
        }
      }

      if (updatedState[index].nav && updatedState[index].number_of_units) {
        const nav = Number(updatedState[index].nav);
        const numberOfUnits = Number(updatedState[index].number_of_units);

        if (!isNaN(nav) && !isNaN(numberOfUnits)) {
          updatedState[index].valuation = truncateToDecimalPlaces(
            nav * numberOfUnits,
            2
          );
        } else {
          updatedState[index].valuation = "0.00"; // Fallback for invalid values
        }
      }

      if (
        !updatedState[index].purchase_value ||
        !updatedState[index].contribution
      ) {
        updatedState[index].number_of_units = "0.00"; // Keep it consistent with string numbers
      }

      if (!updatedState[index].nav || !updatedState[index].number_of_units) {
        updatedState[index].valuation = "0.00"; // Ensure consistent formatting
      }

      // // After the field is updated, calculate the total_investment and valuation if necessary
      // if (updatedState[index].face_value && updatedState[index].number_of_units) {
      //   updatedState[index].total_investment =
      //     Number(updatedState[index].face_value) * Number(updatedState[index].number_of_units);
      // }

      // if (updatedState[index].total_investment && updatedState[index].nav) {
      //   updatedState[index].valuation = (updatedState[index].total_investment * Number(updatedState[index].nav)).toFixed(2);
      // }

      return updatedState;
    });
  };

  useEffect(() => {
    console.log(
      "Updated Scheme Details:",
      schemesDetailsOnTheBasisOfSelectedSchemeAndClass
    );
  }, [schemesDetailsOnTheBasisOfSelectedSchemeAndClass]);

  useEffect(() => {
    if (investorInfo && investorInfo?.schemes) {
      const initialSchemesData = investorInfo.schemes.map((scheme) => {
        const matchingNav =
          allSchemeDetailsForDropdown &&
          allSchemeDetailsForDropdown.length > 0 &&
          allSchemeDetailsForDropdown?.find(
            (nav) =>
              nav?.scheme_name === scheme?.scheme_name &&
              Array.isArray(nav?.nav) && // Ensure nav is an array
              nav?.nav.some((n) => n.class === scheme.scheme_class)
          );

        const navValue = matchingNav
          ? matchingNav?.nav.find((n) => n.class === scheme.scheme_class)
            ?.value || ""
          : "";

        return {
          scheme_name_and_scheme_class: `${scheme?.scheme_name}-${scheme?.scheme_class}`,
          folio_number: scheme?.folio_number,
          ckyc_number: scheme?.ckyc_number,
          scheme_name: scheme?.scheme_name,
          scheme_class: scheme?.scheme_class,
          nav: scheme?.nav || navValue,
          valuation: scheme?.valuation,
          purchase_value: scheme?.purchase_value,
          number_of_units: scheme?.number_of_units,
          contribution: scheme?.contribution,
          documents: scheme?.documents || [],
          contribution_aggrement_date:
            scheme?.contribution_aggrement_date || null, // Add default value for contribution_aggrement_date
          date_of_investment: scheme?.date_of_investment || null, // Add default value for date_of_investment
          date_of_allotement_units: scheme?.date_of_allotement_units || null, // Add default value for date_of_allotement_units
        };
      });

      console.log(
        "setSchemesDetailsOnTheBasisOfSelectedSchemeAndClass(initialSchemesData);",
        initialSchemesData
      );

      setSchemesDetailsOnTheBasisOfSelectedSchemeAndClass(initialSchemesData);
    }
  }, [investorInfo, allSchemeDetailsForDropdown]); // Added allSchemeDetailsForDropdown to dependencies

  const getAllInvestorDetailsForDropdown = async () => {
    const payload = {
      // user_type:userInfo && userInfo.user_type
      user_type: "investor",
    };
    try {
      const response = await getInvestorsDropdown(payload);
      if (response) {
        dispatch(setAllInvestorDetails(response?.data));
      }
    } catch (error) {
      console.log("Error in get all investor dropdown ", error);
    }
  };

  const onSubmit = async (values) => {
    setIsLoading(true);

    const payload = new FormData();

    payload.append("user_id", userId || null);
    payload.append("user_type", "investor");
    payload.append("role_name", "investor");
    payload.append(
      "alternative_email",
      values?.alternative_email || investorInfo?.alternative_email
    );
    payload.append("user_email", values?.email || investorInfo?.user_email);
    payload.append("name", values?.investorName || investorInfo?.name);
    payload.append(
      "contact_person_name",
      values?.contact_person_name || investorInfo?.contact_person_name
    );
    payload.append(
      "mobile_number",
      phoneNumberWithCountryCode || investorInfo?.mobile_number
    );
    payload.append("date_of_birth", values?.dob || investorInfo?.dob);
    // payload.append("portfolio_number", values?.portfolioNumber || investorInfo?.portfolio_number);
    payload.append(
      "number_of_units",
      values?.numberOfUnit || investorInfo?.number_of_units
    );

    payload.append(
      "constitution",
      selectedStatusOrConstitutionOptions || investorInfo?.constitution
    );
    payload.append(
      "pan_number",
      values?.pan_number || investorInfo?.pan_number
    );
    payload.append(
      "demat_account_number",
      values?.demat_account_number || investorInfo?.demat_account_number
    );
    payload.append("address", values?.address || investorInfo?.address);
    payload.append("pincode", values?.pincode || investorInfo?.pincode);
    payload.append("valuation", values?.valuation || investorInfo?.valuation);
    payload.append("country", selectedCountry || investorInfo?.country);
    payload.append("ckyc_number", values?.ckyc || investorInfo?.ckyc_number);
    payload.append("additional_details", null);
    payload.append("template_name", selectedEmailTemplateOptions || null);

    schemesDetailsOnTheBasisOfSelectedSchemeAndClass.forEach(
      (scheme, index) => {
        payload.append(`schemes[${index}][folio_number]`, scheme.folio_number);
        // payload.append(`schemes[${index}][ckyc_number]`, scheme.ckyc_number);
        payload.append(`schemes[${index}][scheme_name]`, scheme.scheme_name);
        payload.append(`schemes[${index}][scheme_class]`, scheme.scheme_class);
        payload.append(`schemes[${index}][nav]`, scheme.nav);
        payload.append(`schemes[${index}][contribution]`, scheme.contribution);
        payload.append(`schemes[${index}][valuation]`, scheme.valuation);
        payload.append(
          `schemes[${index}][purchase_value]`,
          scheme.purchase_value
        );
        payload.append(
          `schemes[${index}][number_of_units]`,
          scheme.number_of_units
        );
        payload.append(
          `schemes[${index}][contribution_aggrement_date]`,
          scheme.contribution_aggrement_date || null
        );
        payload.append(
          `schemes[${index}][date_of_investment]`,
          scheme.date_of_investment || null
        );
        payload.append(
          `schemes[${index}][date_of_allotement_units]`,
          scheme.date_of_allotement_units || null
        );
        // Handle documents for the current scheme
        const documents = scheme.documents || []; // Ensure `documents` exists
        const filesArray = Array.from(documents);
        console.log("selected files", filesArray);

        filesArray.forEach((file) => {
          payload.append(`schemes[${index}][files]`, file); // 'files[]' indicates that it's an array
        });

        console.log("payload", filesArray);

        // const existingFiles = investorInfo?.documents || [];
        const existingFiles = filesArray
          .filter((files) => files.name && files.url && files.type)
          .map((files) => files);
        const validDocuments = existingFiles.filter(
          (doc) => doc.name && doc.url && doc.type
        );
        console.log("valid documents", [...validDocuments]);

        if (validDocuments.length > 0) {
          validDocuments.forEach((file, docIndex) => {
            payload.append(
              `schemes[${index}][documents][${docIndex}][name]`,
              file.name
            );
            payload.append(
              `schemes[${index}][documents][${docIndex}][url]`,
              file.url || ""
            ); // Use file.url if it exists
            payload.append(
              `schemes[${index}][documents][${docIndex}][type]`,
              file.type
            );
          });
        } else {
          // Add null documents if no documents exist for the scheme
          payload.append(`schemes[${index}][documents]`, null);
        }
      }
    );

    try {
      console.log("Payload: ", [...payload], actionType);
      if (actionType !== "View" && actionType !== "Edit") {
        // actionType="View"
        const response = await createInvestor(payload);
        console.log("Response: ", response.code);
        if (response && response?.errors && response?.errors?.length > 0) {
          dispatch(alertDanger(response?.errors[0] || "An error occurred. Please try again."));
          setIsLoading(false);
          return
        }
        if (response.code === 500) {
          dispatch(alertDanger(response.message));

          setIsLoading(false);
          return;
        }
        if (response.code === 404) {
          dispatch(alertDanger(response.message));
          setIsLoading(false);
          return;
        }
        if (response.code === 400) {
          dispatch(alertDanger(response.message));
          setIsLoading(false);
          return;
        }

        if (response.code === 200) {
          console.log("response data", response.data);
          dispatch(alertSuccess("Invester Created Successfully"));
          console.log("userinfo", userInfo);
          console.log("employeeInfo", employeeInfo);
          if (forWhichUserType === "employee") {
            const updatedInvestors = employeeInfo?.investors.map((investor) => {
              // Check if the current investor has the same user_id as in the response
              if (investor.user_id === response.data.user_id) {
                return {
                  ...investor,
                  schemes: response?.data?.schemes.map((scheme) => ({
                    scheme_name: scheme?.scheme_name,
                    scheme_class: scheme?.scheme_class,
                  })),
                };
              }
              return investor;
            });

            // If the user_id doesn't exist, add a new entry
            const isUserIdExists = updatedInvestors.some(
              (investor) => investor.user_id === response.data.user_id
            );

            if (!isUserIdExists) {
              updatedInvestors.push({
                user_id: response.data.user_id,
                schemes: response?.data?.schemes.map((scheme) => ({
                  scheme_name: scheme?.scheme_name,
                  scheme_class: scheme?.scheme_class,
                })),
              });
            }

            const payload = {
              user_id: employeeInfo.user_id,
              email: employeeInfo?.user_email,
              user_email: employeeInfo?.user_email,
              mobile_number: employeeInfo?.mobile_number,
              user_type: "employee",
              name: employeeInfo?.name,
              role_name: "employee",
              designation: employeeInfo?.designation,
              contact_person_name: employeeInfo?.contact_person_name,
              // investors:updatedInvestors,
              investors: employeeInfo?.schemes,
            };
            const updateEmployeeResponse = await editEmployee(payload);
            console.log(
              "response for upadte emplooye while craeting investor",
              updateEmployeeResponse
            );
          }

          setActiveTab("investor");

          getAllInvestor();
          getAllInvestorDetailsForDropdown();
          back();
          setIsLoading(false);
          return;
        }
      }
      if (actionType === "Edit") {
        console.log("FROMM EDIT SEKAR");
        const response = await editInvestor(payload);
        console.log("Response: ", response);
        if (response) {
          if (response?.errors && response?.errors?.length > 0) {
            dispatch(alertDanger(response?.errors[0] || "An error occurred. Please try again."));
            setIsLoading(false);
            return
          }
          if (response.code === 500) {
            dispatch(alertDanger(response.message));
            setIsLoading(false);
            return;
          }
          if (response.code === 404) {
            dispatch(alertDanger(response.message));
            setIsLoading(false);
            return;
          }
          if (response.code === 400) {

            dispatch(alertDanger(response.message));
            setIsLoading(false);
            return;
          }
          if (response.code === 200) {
            dispatch(alertSuccess("Invester Updated successfully"));
            if (forWhichUserType === "employee") {
              getAllInvestor();
              getAllInvestorDetailsForDropdown();
              navigate("/employee");
              setIsLoading(false);
              return;
            }
            setActiveTab("investor");
            getAllInvestor();
            getAllInvestorDetailsForDropdown();
            navigate("/admin");
            setIsLoading(false);
          }
        }
        // setBase64Files([]); // Clear Base64 files after submission
        // setUploadedFiles([])
        return;
      }
    } catch (error) {
      dispatch(alertDanger("Error In Create Investor"));
      console.error("Error in create investor:", error);
      setIsLoading(false);
    }
    // finally {
    //   // setTimeout(() => dispatch(loaderSet(false)), 1000); // Adds a slight delay
    // }
  };


  return (
    <>
      {isLoading && <Loader />}
      <Form
        onSubmit={onSubmit}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <div className="w-full flex flex-col p-6  bg-[#FFFFFF] rounded-md gap-8">
              {(actionType === "Edit" || actionType === "View") && (
                <div className=" w-full flex justify-end items-center ">
                  <Button
                    variant="outline"
                    type="button"
                    size="sm"
                    className=" h-10  gap-1 text-sm w-max self-start "
                    onClick={() => {
                      // dispatch(loaderSet(true))
                      dispatch(nullInvestorInfo());
                      if (forWhichUserType === "employee") {
                        navigate("/employee");
                      }
                      if (forWhichUserType === "admin") {
                        setActiveTab("investor");
                        navigate("/admin");
                      }
                    }}
                  >
                    <IoIosArrowBack />
                    Back
                  </Button>
                </div>
              )}
              <div className="flex w-full justify-between items-center gap-4 ">
                <div className="gap-2 flex flex-col w-[49%]">
                  <Label
                    className="text-start text-[#0D215C] font-bold text-lg"
                    htmlFor="investorName"
                  >
                    Investor Name <span className=" text-red-600">*</span>
                  </Label>
                  <Field
                    id="investorName"
                    type="text"
                    name="investorName"
                    placeholder="Investor Name"
                    actionType={actionType}
                    info={investorInfo && investorInfo?.name}
                    disabled={
                      (actionType === "View" || actionType === "Edit") && true
                    }
                    validate={
                      actionType !== "Edit" && actionType !== "View"
                        ? composeValidators(required)
                        : undefined
                    }
                    component={renderField} // Correct usage of renderField
                    className="bg-muted/40 h-9 w-full rounded-base text-base border-[#3a5dd1] manrope-fontCss"
                  />
                  {/* Reserve space for the error message */}
                  {meta.touched && meta.error && (
                    <p className="text-red-500 text-sm text-left my-[2px]">
                      &nbsp;{meta.error}
                    </p>
                  )}
                </div>
                <div className="flex flex-col  w-[49%] gap-2">
                  <AdvancedDropdown
                    name="Status / Constitution"
                    id="constitution"
                    options={statusOrConstitution}
                    selectedOptions={selectedStatusOrConstitutionOptions}
                    setSelectedOptions={setselectedStatusOrConstitutionOptions}
                    placeholder=""
                    select={"single"}
                    disabled={actionType === "View" && true}
                    required={true}
                  />
                </div>
              </div>
              <div className="flex w-full justify-between items-center gap-4 ">
                <div className="gap-2 w-[49%] flex flex-col">
                  <Label
                    className="text-start text-[#0D215C] font-bold text-lg"
                    htmlFor="dob"
                  >
                    Date Of Birth / Incoporation Date{" "}
                    <span className=" text-red-600">*</span>
                  </Label>
                  <Field
                    id="dob"
                    name="dob"
                    disabled={actionType === "View" && true}
                    component={DatePicker} // Use DatePicker as the component
                    initialValue={investorInfo && investorInfo?.date_of_birth}
                    // validate={required} // Required validation for the date picker
                    className="w-full h-9"
                  />
                </div>

                <div className="gap-2 w-[49%] flex flex-col ">
                  <Label
                    className="text-start text-[#0D215C] font-bold text-lg"
                    htmlFor="contact_person_name"
                  >
                    Contact Person Name<span className=" text-red-600">*</span>
                  </Label>
                  <Field
                    id="contact_person_name"
                    type="text"
                    name="contact_person_name"
                    placeholder="Enter Name"
                    actionType={actionType}
                    info={investorInfo && investorInfo?.contact_person_name}
                    disabled={actionType === "View" && true}
                    validate={
                      actionType !== "Edit" && actionType !== "View"
                        ? composeValidators(required)
                        : undefined
                    }
                    component={renderField} // Correct usage of renderField
                    className="bg-muted/40 h-9 w-full rounded-base text-base border-[#3a5dd1] manrope-fontCss"
                  />

                  {meta.touched && meta.error && (
                    <p className="text-red-500 text-sm text-left my-[2px]">
                      &nbsp;{meta.error}
                    </p>
                  )}
                </div>
              </div>

              <div className="flex w-full justify-between items-center gap-4 ">
                <div className="gap-2 w-[49%] flex flex-col">
                  <Label
                    className="text-start text-[#0D215C] font-bold text-lg"
                    htmlFor="pan_number"
                  >
                    PAN <span className=" text-red-600">*</span>
                  </Label>
                  <Field
                    id="pan_number"
                    type="text"
                    name="pan_number"
                    placeholder="Enter PAN"
                    actionType={actionType}
                    info={investorInfo && investorInfo?.pan_number}
                    disabled={actionType === "View" && true}
                    validate={
                      actionType !== "Edit" && actionType !== "View"
                        ? composeValidators(required)
                        : undefined
                    }
                    component={renderField} // Correct usage of renderField
                    className="bg-muted/40 h-9 w-full rounded-base text-base border-[#3a5dd1] manrope-fontCss"
                  />
                </div>

                <div className="gap-2 w-[49%] flex flex-col ">
                  <Label
                    className="text-start text-[#0D215C] font-bold text-lg"
                    htmlFor="ckyc"
                  >
                    CKYC Number <span className=" text-red-600">*</span>
                  </Label>
                  <Field
                    id="ckyc"
                    type="text"
                    name="ckyc"
                    placeholder="CKYC Number"
                    // validate={composeValidators(required)}
                    disabled={actionType === "View" && true}
                    actionType={actionType}
                    validate={
                      actionType !== "Edit" && actionType !== "View"
                        ? composeValidators(required)
                        : undefined
                    }
                    info={investorInfo && investorInfo?.ckyc_number}
                    component={renderField} // Correct usage of renderField
                    className="bg-muted/40 h-9 w-full rounded-base text-base border-[#3a5dd1] manrope-fontCss"
                  />

                  {meta.touched && meta.error && (
                    <p className="text-red-500 text-sm text-left my-[2px]">
                      &nbsp;{meta.error}
                    </p>
                  )}
                </div>
              </div>
              <div className="flex w-full justify-between items-center gap-4 ">
                <div className="gap-2 w-[49%] flex flex-col ">
                  <Label
                    className="text-start text-[#0D215C] font-bold text-lg"
                    htmlFor="demat_account_number"
                  >
                    Demat A/C No <span className=" text-red-600">*</span>
                  </Label>
                  <Field
                    id="demat_account_number"
                    type="text"
                    name="demat_account_number"
                    placeholder="Enter Demat A/C No"
                    validate={
                      actionType !== "Edit" && actionType !== "View"
                        ? composeValidators(required)
                        : undefined
                    }
                    actionType={actionType}
                    disabled={actionType === "View" && true}
                    info={investorInfo && investorInfo?.demat_account_number}
                    component={renderField} // Correct usage of renderField
                    className="bg-muted/40 h-10 w-full rounded-base text-base border-[#3a5dd1] manrope-fontCss"
                  />

                  {meta.touched && meta.error && (
                    <p className="text-red-500 text-sm text-left my-[2px]">
                      &nbsp;{meta.error}
                    </p>
                  )}
                </div>

                <div className="gap-2 w-[49%] flex flex-col ">
                  <Label
                    className="text-start text-[#0D215C] font-bold text-lg"
                    htmlFor="phoneNumber"
                  >
                    Phone Number <span className=" text-red-600">*</span>{" "}
                  </Label>

                  <div
                    style={{
                      position: "relative",
                      width: "100%",
                      // You can also add media queries for extra control over different screen sizes
                    }}
                  >
                    <PhoneInput
                      country={"in"} // Set the default country code
                      value={phoneNumberWithCountryCode} // Value to display
                      onChange={(value) => {
                        console.log("Phone Number", value);
                        setPhoneNumberWithCountryCode(value);
                      }} // Update state on change
                      disableSearchIcon
                      disabled={actionType === "View"} // Disable the field if actionType is 'View'
                      placeholder="Enter phone number"
                      enableSearch
                      countryCodeEditable={false} // Display the country calling code and make it non-editable
                      // Input style
                      inputStyle={{
                        width: "100%",
                        height: "2.25rem",
                        padding: "0.5rem",
                        paddingLeft: "3.5rem", // Space for the country code button
                        borderRadius: "0.375rem",
                        border: "1px solid #3a5dd1",
                        display: "inline-block",
                        boxSizing: "border-box",
                      }}
                      // Country code button style
                      buttonStyle={{
                        height: "2.25rem",
                        width: "3.5rem",
                        padding: "0 0.5rem",
                        borderLeft: "1px solid #3a5dd1", // Add border only on the left
                        borderTop: "1px solid #3a5dd1", // Add border only on the top
                        borderBottom: "1px solid #3a5dd1", // Add border only on the bottom
                        borderRight: "none", // Remove border on the right
                        outline: "none",
                        boxSizing: "border-box",

                        // Border radius
                        borderTopLeftRadius: "0.375rem", // Rounded top-left corner
                        borderBottomLeftRadius: "0.375rem", // Rounded bottom-left corner
                        borderTopRightRadius: "0", // Square top-right corner
                        borderBottomRightRadius: "0", // Square bottom-right corner
                      }}
                      dropdownStyle={{
                        maxHeight: "300px",
                        overflowY: "auto",

                        top: "100%",
                        left: 0,
                      }}
                      // Search bar styles
                      searchStyle={{
                        width: "100%",
                        height: "2.25rem",
                        padding: "0.5rem",
                        borderRadius: "0.375rem",
                        border: "1px solid #3a5dd1",
                        boxSizing: "border-box",
                      }}
                    />
                  </div>

                  {/* Reserve space for the error message */}
                  {meta.touched && meta.error && (
                    <p className="text-red-500 text-sm text-left my-[2px]">
                      &nbsp;{meta.error}
                    </p>
                  )}
                </div>
              </div>
              <div className="flex w-full justify-between items-center gap-4 ">
                <div className="gap-2 w-full flex flex-col ">
                  <Label
                    className="text-start text-[#0D215C] font-bold text-lg"
                    htmlFor="ckyc"
                  >
                    Address <span className=" text-red-600">*</span>
                  </Label>
                  <Field
                    actionType={actionType}
                    info={investorInfo && investorInfo?.address}
                    id="address"
                    type="textarea"
                    name="address"
                    placeholder="Enter Address"
                    // validate={composeValidators(required)}
                    validate={
                      actionType !== "Edit" && actionType !== "View"
                        ? composeValidators(required)
                        : undefined
                    }
                    component={renderField}
                    className="bg-muted/40 min-h-9 max-h-20 w-full rounded-md text-base border p-2 border-[#3a5dd1] manrope-fontCss placeholder: placeholder: focus:outline-none"
                  />

                  {/* <textarea name="tickerMessage" id="tickerMessage" className=' bg-muted/40 rounded-base text-base border-[#3a5dd1] manrope-fontCss ' ></textarea> */}
                </div>
              </div>

              <div className="flex w-full justify-between items-center gap-4 ">
                <div className="flex flex-col w-[49%] gap-2">
                  <Label
                    className="text-start text-[#0D215C] font-bold text-lg"
                    htmlFor="country"
                  >
                    Country <span className=" text-red-600">*</span>{" "}
                  </Label>
                  <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                      <Button
                        ref={buttonRef}
                        id="country"
                        variant="outline"
                        size="lg"
                        className="h-10 gap-1 w-full text-md flex border-[#3a5dd1] justify-between"
                      >
                        <span className="sr-only sm:not-sr-only">
                          {selectedCountry}
                        </span>
                        <span className="ml-1 text-[#0D215C]">
                          <IoIosArrowDown />
                        </span>
                      </Button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent
                      className={`w-[var(--radix-dropdown-menu-trigger-width)]  max-h-[300px]`}
                    >
                      <DropdownMenuLabel>Country </DropdownMenuLabel>
                      <DropdownMenuSeparator />
                      {/* Search bar to filter countries */}
                      <div className="p-2">
                        <label htmlFor="investor-country-search" className="sr-only">Search country</label>
                        <input
                          id="investor-country-search"
                          type="text"
                          value={searchCountry}
                          onChange={(e) => {
                            e.stopPropagation(); // Stops propagation to prevent menu closing
                            setSearchCountry(e.target.value);
                          }}
                          placeholder="Search country"
                          aria-label="Search country"
                          className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                      </div>
                      <DropdownMenuSeparator />
                      {/* Dynamically render the list of filtered countries */}
                      {filteredCountries.length > 0 ? (
                        filteredCountries.map((country, index) => (
                          <DropdownMenuCheckboxItem
                            key={index}
                            checked={selectedCountry === country}
                            onCheckedChange={() => setSelectedCountry(country)}
                          >
                            {country}
                          </DropdownMenuCheckboxItem>
                        ))
                      ) : (
                        <p className="text-gray-500 p-2" role="status" aria-live="polite">No results found</p>
                      )}
                    </DropdownMenuContent>
                  </DropdownMenu>
                </div>

                <div className="gap-2 w-[49%] flex flex-col ">
                  <Label
                    className="text-start text-[#0D215C] font-bold text-lg"
                    htmlFor="pincode"
                  >
                    Pincode <span className=" text-red-600">*</span>
                  </Label>
                  <Field
                    id="pincode"
                    type="text"
                    name="pincode"
                    placeholder="Enter Pincode"
                    onKeyDown={(event) => pinCodeRestriction(event)}
                    actionType={actionType}
                    disabled={actionType === "View" && true}
                    info={investorInfo && investorInfo?.pincode}
                    validate={
                      actionType !== "Edit" && actionType !== "View"
                        ? composeValidators(required)
                        : undefined
                    }
                    component={renderField} // Correct usage of renderField
                    className="bg-muted/40 h-10 w-full rounded-base text-base border-[#3a5dd1] manrope-fontCss"
                  />

                  {meta.touched && meta.error && (
                    <p className="text-red-500 text-sm text-left my-[2px]">
                      &nbsp;{meta.error}
                    </p>
                  )}
                </div>
              </div>
              <div className="flex w-full justify-between items-center gap-4 ">
                {/* Ticker name Input field */}

                <div className="gap-2 w-[49%] flex flex-col ">
                  <Label
                    className="text-start text-[#0D215C] font-bold text-lg"
                    htmlFor="email"
                  >
                    Email <span className=" text-red-600">*</span>
                  </Label>
                  <Field
                    id="email"
                    type="text"
                    name="email"
                    placeholder="Enter Email"
                    actionType={actionType}
                    info={investorInfo && investorInfo?.user_email}
                    disabled={
                      (actionType === "View" || actionType === "Edit") && true
                    }
                    validate={
                      actionType !== "Edit" && actionType !== "View"
                        ? composeValidators(required)
                        : undefined
                    }
                    component={renderField} // Correct usage of renderField
                    className="bg-muted/40 h-9 w-full rounded-base text-base border-[#3a5dd1] manrope-fontCss"
                  />

                  {meta.touched && meta.error && (
                    <p
                      className={`text-red-500 text-sm h-5 text-left ${meta.touched && meta.error ? "" : "invisible"
                        }`}
                    >
                      &nbsp;{meta.error}
                    </p>
                  )}
                </div>
                <div className="gap-2 flex flex-col w-[49%]">
                  <Label
                    className="text-start text-[#0D215C] font-bold text-lg"
                    htmlFor="alternative_email"
                  >
                    Alternate Email
                  </Label>
                  <Field
                    id="alternative_email"
                    type="text"
                    name="alternative_email"
                    placeholder="Investor Alternate Email"
                    actionType={actionType}
                    info={investorInfo && investorInfo?.alternative_email}
                    // disabled={
                    //   (actionType === "View" || actionType === "Edit") && true
                    // }
                    disabled={actionType === "View" && true}
                    // validate={
                    //   actionType !== "Edit" ? composeValidators(required) : undefined
                    // }
                    component={renderField} // Correct usage of renderField
                    className="bg-muted/40 h-9 w-full rounded-base text-base border-[#3a5dd1] manrope-fontCss"
                  />
                  {/* Reserve space for the error message */}
                  {meta.touched && meta.error && (
                    <p
                      className={`text-red-500 text-sm h-5 text-left ${meta.touched && meta.error ? "" : "invisible"
                        }`}
                    >
                      &nbsp;{meta.error}
                    </p>
                  )}
                </div>
              </div>
              <div className="flex w-full justify-between items-center gap-4 ">
                {/* Ticker name Input field */}
                {/* Dropdown Menu */}
                <div className="flex flex-col  w-[49%] gap-2">
                  <AdvancedDropdown
                    name="Scheme"
                    id="scheme"
                    options={schemeOption}
                    selectedOptions={selectedSchemeOptions}
                    setSelectedOptions={setSelectedSchemeOptions}
                    placeholder="Scheme"
                    select={"single"}
                    disabled={actionType === "View" && true}
                    required={true}
                  />
                </div>

                <div className="flex flex-col  w-[49%] gap-2">
                  <AdvancedDropdown
                    name="Class"
                    id="class"
                    options={classOption}
                    selectedOptions={selectedClassOptions}
                    setSelectedOptions={setSelectedClassOptions}
                    placeholder="Class"
                    select={"single"}
                    disabled={actionType === "View" && true}
                    required={true}
                  />
                </div>
              </div>
              {selectedSChemeAndCLass?.length > 0 && (
                <div className="flex w-full  items-center gap-4 border border-[#3a5dd1] rounded-lg  p-10 flex-wrap ">
                  {selectedSChemeAndCLass?.length > 0 &&
                    selectedSChemeAndCLass.map((item, index) => (
                      <div
                        key={index}
                        className="flex gap-8 justify-center items-center bg-[#0D215C] text-white text-sm rounded-xl px-4 py-2 font-bold  "
                      >
                        <span>{item}</span>
                        <div
                          className="rounded-full bg-red-500  flex items-center justify-center h-5 w-5 p-1 text-xs cursor-default "
                          onClick={
                            actionType !== "View"
                              ? () => handleRemoveSchemeAndClass(index)
                              : undefined
                          }
                        >
                          {"X"}
                        </div>
                      </div>
                    ))}
                </div>
              )}

              <Tabs>
                <div className="flex bg-white items-center flex-col">
                  <div className="flex w-full flex-col items-start mt-2">
                    {selectedSChemeAndCLass &&
                      selectedSChemeAndCLass.length > 0 && (
                        <TabsList className="bg-white border-b-2 gap-4 w-full rounded-none flex justify-start">
                          {selectedSChemeAndCLass.map((curElem, index) => (
                            <TabsTrigger
                              key={index}
                              value={curElem}
                              tabIndex={index + 1}
                              className="data-[state=active]:text-[#0D215C] data-[state=active]:font-bold"
                            >
                              {curElem}
                            </TabsTrigger>
                          ))}
                        </TabsList>
                      )}
                  </div>
                </div>

                {selectedSChemeAndCLass.map((scheme, index) => (
                  <TabsContent key={index} value={scheme}>
                    <div className="w-full flex flex-col p-6  bg-[#FFFFFF] rounded-md gap-8">
                      <div className="flex w-full justify-between items-center gap-4">
                        <div className="gap-2 w-[49%] flex flex-col">
                          <Label
                            className="text-start text-[#0D215C] font-bold text-lg"
                            htmlFor={`folio_number-${index}`}
                          >
                            Folio Number{" "}
                            <span className=" text-red-600">*</span>
                          </Label>
                          <input
                            id={`folio_number-${index}`}
                            type="text"
                            placeholder="Folio Number"
                            onKeyDown={(event) =>
                              preventNonNumericAndRestrictLength(event)
                            }
                            // disabled={actionType==="View" || (actionType==="Edit" && schemesDetailsOnTheBasisOfSelectedSchemeAndClass[index]?.portfolio_number )}
                            disabled={actionType === "View"}
                            value={
                              schemesDetailsOnTheBasisOfSelectedSchemeAndClass[
                                index
                              ]?.folio_number || ""
                            }
                            onChange={(e) => {
                              handleFieldChange(
                                index,
                                "folio_number",
                                e.target.value
                              );
                              validateField(
                                "folio_number",
                                e.target.value,
                                index
                              ); // Call the validation function
                            }}
                            onBlur={(e) =>
                              validateField(
                                "folio_number",
                                e.target.value,
                                index
                              )
                            }
                            className={`bg-muted/40 h-9 w-full rounded-base text-base border border-[#3a5dd1] p-2 rounded-md focus:outline-none manrope-fontCss ${actionType !== "View" ? "cursor-default" : "cursor-not-allowed"}`}
                          // className={`bg-muted/40 h-9 w-full rounded-base text-base border ${
                          //   validationErrors[`folio_number-${index}`] ? "border-red-500" : "border-[#3a5dd1]"
                          // } p-2 rounded-md focus:outline-none manrope-fontCss ${
                          //   actionType !== "View" ? "cursor-default" : "cursor-not-allowed"
                          // }`}
                          />
                          {validationErrors[`folio_number-${index}`] && (
                            <p className="text-red-500 text-sm text-left my-[2px]">
                              {validationErrors[`folio_number-${index}`]}
                            </p>
                          )}
                        </div>
                        <div className="gap-2 w-[49%] flex flex-col">
                          <Label
                            className="text-start text-[#0D215C] font-bold text-lg"
                            htmlFor={`contribution-${index}`}
                          >
                            Contribution (
                            <span className="inline-block align-middle">
                              <IndianRupee size={18} />
                            </span>
                            ) <span className=" text-red-600">*</span>
                          </Label>
                          <input
                            id={`contribution-${index}`}
                            type="text"
                            placeholder="Contribution"
                            // disabled
                            onKeyDown={(event) =>
                              preventNonNumericAndRestrictDecimal(event)
                            }
                            value={
                              schemesDetailsOnTheBasisOfSelectedSchemeAndClass[
                                index
                              ]?.contribution || ""
                            }
                            onChange={(e) => {
                              handleFieldChange(
                                index,
                                "contribution",
                                e.target.value
                              );
                              validateField(
                                "contribution",
                                e.target.value,
                                index
                              ); // Call the validation function
                            }}
                            onBlur={(e) =>
                              validateField(
                                "contribution",
                                e.target.value,
                                index
                              )
                            }
                            // onChange={(e) => handleFieldChange(index, "contribution", e.target.value)}
                            className={`bg-muted/40 h-9 w-full rounded-base text-base border border-[#3a5dd1] p-2 rounded-md focus:outline-none manrope-fontCss cursor-pointer`}
                          />
                          {validationErrors[`contribution-${index}`] && (
                            <p className="text-red-500 text-sm text-left my-[2px]">
                              {validationErrors[`contribution-${index}`]}
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="flex w-full justify-between items-center gap-4">
                        <div className="gap-2 w-[49%] flex flex-col">
                          <Label
                            className="text-start text-[#0D215C] font-bold text-lg"
                            htmlFor={`contribution_aggrement_date-${index}`}
                          >
                            Contribution Agreement Date{" "}
                            <span className=" text-red-600">*</span>
                          </Label>
                          <DatePickerForSchemes
                            id={`contribution_aggrement_date-${index}`}
                            name={`contribution_aggrement_date-${index}`}
                            disabled={actionType === "View" && true}
                            onChange={(date) =>
                              handleFieldChange(
                                index,
                                "contribution_aggrement_date",
                                date
                              )
                            }
                            value={
                              schemesDetailsOnTheBasisOfSelectedSchemeAndClass[
                                index
                              ]?.contribution_aggrement_date || ""
                            }
                            // validate={required} // Required validation for the date picker

                            className="w-full h-9"
                          />
                        </div>
                        <div className="gap-2 w-[49%] flex flex-col">
                          <Label
                            className="text-start text-[#0D215C] font-bold text-lg"
                            htmlFor={`purchase_value-${index}`}
                          >
                            Purchase Value / Per Unit{" "}
                            <span className=" text-red-600">*</span>
                          </Label>
                          <input
                            id={`purchase_value-${index}`}
                            type="text"
                            placeholder="Purchase Value"
                            onKeyDown={(event) =>
                              preventNonNumericAndRestrictDecimal(event)
                            }
                            disabled={actionType === "View"}
                            value={
                              schemesDetailsOnTheBasisOfSelectedSchemeAndClass[
                                index
                              ]?.purchase_value || ""
                            }
                            // onChange={(e) => handleFieldChange(index, "purchase_value", e.target.value)}
                            onChange={(e) => {
                              handleFieldChange(
                                index,
                                "purchase_value",
                                e.target.value
                              );
                              validateField(
                                "purchase_value",
                                e.target.value,
                                index
                              ); // Call the validation function
                            }}
                            onBlur={(e) =>
                              validateField(
                                "purchase_value",
                                e.target.value,
                                index
                              )
                            }
                            className={`bg-muted/40 h-9 w-full rounded-base text-base border border-[#3a5dd1] p-2 rounded-md focus:outline-none manrope-fontCss ${actionType !== "View" ? "cursor-default" : "cursor-not-allowed"}`}
                          />
                          {validationErrors[`purchase_value-${index}`] && (
                            <p className="text-red-500 text-sm text-left my-[2px]">
                              {validationErrors[`purchase_value-${index}`]}
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="flex w-full justify-between items-center gap-4">
                        <div className="gap-2 w-[49%] flex flex-col">
                          <Label
                            className="text-start text-[#0D215C] font-bold text-lg"
                            htmlFor={`numberOfUnit-${index}`}
                          >
                            Number Of Unit Held{" "}
                            <span className=" text-red-600">*</span>
                          </Label>
                          <input
                            id={`numberOfUnit-${index}`}
                            type="text"
                            placeholder="Number Of Unit"
                            // onKeyDown={ (event) => preventNonNumericAndRestrictLength(event)}
                            disabled
                            value={
                              schemesDetailsOnTheBasisOfSelectedSchemeAndClass[
                                index
                              ]?.number_of_units
                                ? Number(
                                  schemesDetailsOnTheBasisOfSelectedSchemeAndClass[
                                    index
                                  ]?.number_of_units
                                ).toLocaleString("en-IN")
                                : 0
                            }
                            onChange={(e) =>
                              handleFieldChange(
                                index,
                                "number_of_units",
                                e.target.value
                              )
                            }
                            //   onChange={(e) =>{
                            //     handleFieldChange(index, "number_of_units", e.target.value)
                            //     validateField("number_of_units", e.target.value,index); // Call the validation function

                            //  }}

                            //  onBlur={(e) => validateField("number_of_units", e.target.value,index)}

                            className={`bg-muted/40 h-9 w-full rounded-base text-base border border-[#3a5dd1] p-2 rounded-md focus:outline-none manrope-fontCss cursor-not-allowed`}
                          />
                          {/* {validationErrors[`number_of_units-${index}`] && (
        <p className="text-red-500 text-sm text-left my-[2px]">
          {validationErrors[`number_of_units-${index}`]}
        </p>
      )} */}
                        </div>
                        <div className="gap-2 w-[49%] flex flex-col">
                          <Label
                            className="text-start text-[#0D215C] font-bold text-lg"
                            htmlFor={`date_of_investment-${index}`}
                          >
                            Date of Investment
                          </Label>
                          <DatePickerForSchemes
                            id={`date_of_investment-${index}`}
                            name={`date_of_investment-${index}`}
                            disabled={actionType === "View" && true}
                            onChange={(date) =>
                              handleFieldChange(
                                index,
                                "date_of_investment",
                                date
                              )
                            }
                            value={
                              schemesDetailsOnTheBasisOfSelectedSchemeAndClass[
                                index
                              ]?.date_of_investment || ""
                            }
                            // validate={required} // Required validation for the date picker
                            className="w-full h-9"
                          />
                        </div>
                      </div>

                      <div className="flex w-full justify-between items-center gap-4">
                        <div className="gap-2 w-[49%] flex flex-col">
                          <Label
                            className="text-start text-[#0D215C] font-bold text-lg"
                            htmlFor={`date_of_allotement_units-${index}`}
                          >
                            Date of Allotement of Units{" "}
                            <span className=" text-red-600">*</span>
                          </Label>
                          <DatePickerForSchemes
                            id={`date_of_allotement_units-${index}`}
                            name={`date_of_allotement_units-${index}`}
                            disabled={actionType === "View" && true}
                            value={
                              schemesDetailsOnTheBasisOfSelectedSchemeAndClass[
                                index
                              ]?.date_of_allotement_units || ""
                            }
                            // validate={required} // Required validation for the date picker
                            onChange={(date) =>
                              handleFieldChange(
                                index,
                                "date_of_allotement_units",
                                date
                              )
                            }
                            className="w-full h-9"
                          />
                        </div>

                        <div className="gap-2 w-[49%] flex flex-col">
                          <Label
                            className="text-start text-[#0D215C] font-bold text-lg"
                            htmlFor={`valuation-${index}`}
                          >
                            Valuation (
                            <span className="inline-block align-middle">
                              <IndianRupee size={18} />
                            </span>
                            ) <span className=" text-red-600">*</span>
                          </Label>
                          <input
                            id={`valuation-${index}`}
                            type="text"
                            placeholder="Valuation"
                            disabled
                            value={
                              schemesDetailsOnTheBasisOfSelectedSchemeAndClass[
                                index
                              ]?.valuation
                                ? Number(
                                  schemesDetailsOnTheBasisOfSelectedSchemeAndClass[
                                    index
                                  ]?.valuation
                                ).toLocaleString("en-IN")
                                : 0
                            }
                            onChange={(e) =>
                              handleFieldChange(
                                index,
                                "valuation",
                                e.target.value
                              )
                            }
                            className="bg-muted/40 h-9 w-full cursor-not-allowed rounded-base text-base border border-[#3a5dd1] p-2 rounded-md focus:outline-none manrope-fontCss"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="w-full h-2 rounded-md bg-muted mb-4"></div>

                    <div className="w-full flex flex-col min-h-32">
                      <div className="flex flex-row justify-between mb-4">
                        <span className="text-start text-[#0D215C] font-bold text-lg">
                          Scheme Documents{" "}
                          <span className=" text-red-600">*</span>{" "}
                        </span>

                        <Button
                          className="w-[20%] bg-[#0D215C] "
                          type="button"
                          disabled={actionType === "View" && true}
                          onClick={() =>
                            document.getElementById("fileUpload").click()
                          }
                        >
                          Add Document
                        </Button>
                        <input
                          id="fileUpload"
                          type="file"
                          accept=".xls,.xlsx,.pdf,.doc,.docx"
                          multiple
                          style={{ display: "none" }} // Hidden input
                          onChange={(e) => handleFileUpload(e, index)}
                        />
                      </div>

                      <div className="mt-4">
                        {schemesDetailsOnTheBasisOfSelectedSchemeAndClass[index]
                          ?.documents?.length > 0 ? (
                          <div className="file-list flex flex-col gap-2">
                            {schemesDetailsOnTheBasisOfSelectedSchemeAndClass[
                              index
                            ]?.documents?.map((file, fileIndex) => (
                              <div
                                key={fileIndex}
                                className="flex justify-between items-center p-2 border border-gray-300 rounded-md"
                              >
                                <span>{file.name}</span>
                                <button
                                  type="button"
                                  onClick={
                                    actionType !== "View"
                                      ? () => handleRemoveFile(index, fileIndex)
                                      : undefined
                                  }
                                  className="text-red-500 hover:underline"
                                >
                                  Remove
                                </button>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <p className="text-gray-500">No files uploaded</p>
                        )}
                      </div>
                    </div>
                  </TabsContent>
                ))}
              </Tabs>

              <div className="w-full h-2 rounded-md bg-muted "></div>
              <div className="flex w-full justify-end gap-2">
                {actionType !== "View" && (
                  // && actionType!=="Edit"

                  <div className=" h-10 w-[20%] gap-2">
                    <AdvancedDropdown
                      name="Email Template"
                      id="emailTemplate"
                      options={emailTemplateOption}
                      selectedOptions={selectedEmailTemplateOptions}
                      setSelectedOptions={setSelectedEmailTemplateOptions}
                      placeholder="Email Template"
                      select={"single"}
                      label={false}
                    //    disabled={selectedSchemeOptions.length===0 && true}
                    />
                  </div>
                )}
                {actionType !== "View" && (
                  <Button
                    type="submit"
                    className="w-[20%] h-10 bg-[#0D215C] self-end "
                  >
                    {actionType === "Edit" ? "Save Changes" : "Create User"}
                  </Button>
                )}
              </div>
            </div>
          </form>
        )}
      />

      <Dialog
        open={isOpenUploadDocumentConfirmation}
        onOpenChange={handleIsCloseUploadDocumentConfirmation}
      >
        {/* Overlay */}
        <DialogOverlay className="fixed inset-0 bg-black bg-opacity-50 z-40" />

        {/* Dialog Content */}
        <DialogContent className="fixed inset-0 m-auto bg-white z-50 p-6 rounded-lg h-64 shadow-lg max-w-lg w-full flex flex-col justify-between">
          <div>
            <DialogTitle className="text-lg font-bold">
              Upload Document Confirmation
            </DialogTitle>
            <DialogDescription className="mt-2">
              Do you want to upload the document now?
            </DialogDescription>
          </div>
          <div className="mt-4 flex justify-end gap-4">
            <Button
              type="button"
              className="bg-red-700 text-white  "
              onClick={handleIsCloseUploadDocumentConfirmation}
            >
              Close
            </Button>
            <Button type="button" className="bg-[#0D215C] text-white  ">
              Confirm Upload
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default CreateInvestor;
